import React from "react";
import "./Ordersv2.scss";
import OrdersTabsv2 from "../ordersTabsv2/ordersTabsv2"

function Ordersv2(props) {
  const {setCount} = props;
  return (
    <OrdersTabsv2 setCount={setCount}/>
  );
}

export default Ordersv2;

